var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillCheckBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7V6.37C21 5.177 21 4.58 20.842 4.1C20.6982 3.65441 20.4537 3.24792 20.1275 2.91202C19.8013 2.57612 19.4022 2.31982 18.961 2.163C18.493 2 17.914 2 16.755 2H7.245C6.086 2 5.507 2 5.039 2.163C4.59793 2.31972 4.19885 2.57586 3.87267 2.91158C3.54649 3.24731 3.30195 3.6536 3.158 4.099C3 4.581 3 5.177 3 6.37V15M21 11V20.374C21 21.232 20.015 21.688 19.392 21.118C19.2172 20.9565 18.988 20.8668 18.75 20.8668C18.512 20.8668 18.2828 20.9565 18.108 21.118L17.625 21.56C17.3188 21.8432 16.9171 22.0004 16.5 22.0004C16.0829 22.0004 15.6812 21.8432 15.375 21.56C15.0688 21.2768 14.6671 21.1196 14.25 21.1196C13.8329 21.1196 13.4312 21.2768 13.125 21.56C12.8188 21.8432 12.4171 22.0004 12 22.0004C11.5829 22.0004 11.1812 21.8432 10.875 21.56C10.5688 21.2768 10.1671 21.1196 9.75 21.1196C9.33293 21.1196 8.93121 21.2768 8.625 21.56C8.31879 21.8432 7.91707 22.0004 7.5 22.0004C7.08293 22.0004 6.68121 21.8432 6.375 21.56L5.892 21.118C5.71721 20.9565 5.48798 20.8668 5.25 20.8668C5.01202 20.8668 4.78279 20.9565 4.608 21.118C3.985 21.688 3 21.232 3 20.374V19",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.4L10.929 12L14.5 8",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.5H9M16.5 15.5H12",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillCheckBroken);
export default __webpack_public_path__ + "static/media/bill-check-broken.6b11bcd3d4c44c3ccd68ba97b28245fc.svg";
export { ForwardRef as ReactComponent };